import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { getFromStorage, getSessionId } from '../../helpers/storageUtils';
import { UtilsService } from '../../services/utils.service';
import {
  MembershipRequest,
  MembershipResponse,
  MembershipTokenResponse,
} from '../interfaces/membership.interface';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class MembershipService {
  private apiUrlMembership = environment.URL_MEMBRESIA;
  private apiUrlMembershipToken = environment.URL_MEMBRESIA_TOKEN;
  private tokenService = inject(TokenService);
  private sessionId: string = getFromStorage('session_id') || '0';
  private http = inject(HttpClient);
  private utils = inject(UtilsService);
  SESSION_ID = getSessionId().toString();

  constructor() {}

  /**
   * Obtiene la URL para abrir el lightbox de la pasarela de pagos.
   * @param product El producto que se está pagando.
   * @param recordId El ID del registro asociado al pago.
   * @param type El tipo de transacción ('payment' o 'subscription').
   * @returns Un Observable con la respuesta del backend que incluye la processUrl.
   */
  getLightboxUrl(
    sessionId: string,
    recordId: string,
    type: 'payment' | 'subscription',
    product = 'Motos',
  ): Observable<MembershipResponse> {
    const headers = this.utils.getHeaders(sessionId || this.SESSION_ID);

    const userAgent = navigator.userAgent;

    const ipAddressPlaceholder = '0.0.0.0';

    const payload: MembershipRequest = {
      product,
      input: {
        recordId: recordId,
        type: type,
        ipAddress: ipAddressPlaceholder, // El backend debe encargarse de la IP real
        userAgent: userAgent,
      },
    };

    // 4. Realizar la llamada HTTP POST al backend
    return this.http.post<MembershipResponse>(this.apiUrlMembership, payload, {
      headers: headers,
    });
  }

  /**
   * Obtiene la respuesta del proceso de pago.
   * @param recordId El ID del registro asociado al pago.
   * @returns Un Observable con la respuesta del backend que incluye la respuesta.
   */
  getTokenResponse(
    sessionId: string,
    recordId: string,
    product = 'Motos',
  ): Observable<MembershipTokenResponse> {
    const headers = this.utils.getHeaders(sessionId || this.SESSION_ID);

    const requestBody = {
      product,
      input: { recordId },
    };

    return this.http.post<MembershipTokenResponse>(this.apiUrlMembershipToken, requestBody, {
      headers: headers,
    });
  }
}
